export enum AssetParametersType {
	DOCUMENT = 'DOCUMENT',
	DASHBOARD = 'DASHBOARD',
	WIDGET = 'WIDGET',
	QUICK_INSIGHT_WIDGET = 'QUICK_INSIGHT_WIDGET',
	HOME_PAGE_CUSTOM_WIDGET = 'HOME_PAGE_CUSTOM_WIDGET',
}
